/* src/app/app.component.scss */
ion-tab-button {
  position: relative;
}
ion-tab-button ion-icon {
  fill: var(--ion-color-secondary);
}
ion-tab-button.tab-selected ion-icon {
  fill: var(--ion-color-primary) !important;
}
ion-tab-bar {
  --background: white;
  box-shadow: 0px -4px 15px 0px rgba(79, 97, 79, 0.1490196078);
}
ion-label {
  margin-top: 10px;
  font-family: AppFont, sans-serif;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: var(--ion-color-secondary);
}
.selected ion-icon {
  fill: var(--ion-color-primary) !important;
}
.selected ion-label {
  color: var(--ion-color-primary);
}
.order-index {
  position: absolute;
  background: var(--ion-color-primary);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  right: 15px;
  top: 1px;
  z-index: 99;
  transition: all 0.3s linear;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-index p {
  font-size: 12px;
  color: white;
}
.hidden {
  opacity: 0;
  height: 0;
  transition: all 0.3s linear;
}
.splash {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  background: black;
}
.splash {
  width: 100%;
  height: 100%;
}
.splash ion-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}
.fullscreen-bg {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: -100;
  position: absolute;
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=app.component.css.map */
